import React from 'react';
import { Fade, Grid, Card, CardContent, Box, Typography } from '@mui/material';
import { People as PeopleIcon, Group as GroupIcon } from '@mui/icons-material';
import Chart from 'react-apexcharts';

const DemographicsTab = ({ data = {} }) => {
  const genderDistribution = data?.genderDistribution || [];
  const roleDistribution = data?.roleDistribution || [];

  const genderChartData = {
    options: {
      chart: {
        type: 'pie',
        animations: { enabled: true, easing: 'easeinout', speed: 800 },
      },
      labels: genderDistribution.map((item) => item._id || 'Unknown'),
      colors: ['#1976d2', '#9c27b0', '#2e7d32', '#f57c00', '#d32f2f'],
      legend: { position: 'bottom', fontSize: '14px', fontWeight: 500 },
      dataLabels: {
        enabled: true,
        style: { fontSize: '12px', fontWeight: 'bold' },
      },
      plotOptions: {
        pie: {
          expandOnClick: true,
          donut: { size: '70%' },
        },
      },
    },
    series: genderDistribution.map((item) => item.count || 0),
  };

  const roleChartData = {
    options: {
      chart: {
        type: 'donut',
        animations: { enabled: true, easing: 'easeinout', speed: 800 },
      },
      labels: roleDistribution.map((item) => item._id || 'Unknown'),
      colors: ['#9c27b0', '#1976d2', '#2e7d32', '#f57c00', '#ed6c02'],
      legend: { position: 'bottom', fontSize: '14px', fontWeight: 500 },
      dataLabels: {
        enabled: true,
        style: { fontSize: '12px', fontWeight: 'bold' },
      },
      plotOptions: {
        pie: {
          expandOnClick: true,
          donut: { size: '70%' },
        },
      },
    },
    series: roleDistribution.map((item) => item.count || 0),
  };

  return (
    <Fade in timeout={500}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
              borderRadius: 2,
              transition: 'all 0.3s ease-in-out',
              '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'primary.lighter',
                  mr: 2,
                }}
              >
                <PeopleIcon sx={{ fontSize: 28, color: 'primary.main' }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                Gender Distribution
              </Typography>
            </Box>
            <Chart options={genderChartData.options} series={genderChartData.series} type="pie" height={300} />
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              boxShadow: '0px 2px 6px 0px rgba(13, 10, 44, 0.08)',
              borderRadius: 2,
              transition: 'all 0.3s ease-in-out',
              '&:hover': { boxShadow: '0px 4px 12px 0px rgba(13, 10, 44, 0.12)', transform: 'translateY(-2px)' },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'secondary.lighter',
                  mr: 2,
                }}
              >
                <GroupIcon sx={{ fontSize: 28, color: 'secondary.main' }} />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.titles' }}>
                Role Distribution
              </Typography>
            </Box>
            <Chart options={roleChartData.options} series={roleChartData.series} type="donut" height={300} />
          </Card>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default DemographicsTab;

